import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconEdit = (props) => (
  <SvgIcon {...props}>
    <path d="M4.5,20.1l4.4-2.5l-2.4-2.2L4.5,20.1z M17.1,3.9L7.6,14.3l2.4,2.2L19.5,6L17.1,3.9z"/>
  </SvgIcon>
);
// IconEdit = pure(IconEdit);
IconEdit.displayName = 'IconEdit';
IconEdit.muiName = 'SvgIcon';

export default IconEdit;



// WEBPACK FOOTER //
// ./src/components/Icons/IconEdit.js